export const createStudentRowStyles = (theme: any) => {
  const isDark = theme?.palette?.mode === 'dark';

  return {
    studentRow: {
      alignItems: 'center',
      borderBottom: `1px solid ${theme.palette.divider}`,
      display: 'flex',
      gap: '0.5rem',
      px: '4px',
      py: '6px',
      [theme.breakpoints.up('md')]: {
        '&:hover': { backgroundColor: theme.palette.action.hover },
      },
    },
    avatar: {
      flexShrink: 0,
      height: '32px',
      fontSize: '1rem',
      width: '32px',
      cursor: 'auto',
    },
    addedStudentAvatar: { opacity: 0.4 },
    studentDetails: { flex: '1 1 0%', minWidth: 0, overflow: 'hidden' },
    studentName: {
      alignItems: 'center',
      display: 'flex',
      fontSize: '16px',
      maxWidth: '100%',
      minWidth: 0,
      overflow: 'hidden',
      whiteSpace: 'nowrap',
    },
    studentNameText: {
      display: 'block',
      flexShrink: 1,
      fontFamily: theme.typography.fontFamily,
      maxWidth: '100%',
      minWidth: 0,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
    addedStudentText: { color: 'text.secondary' },
    studentEmail: {
      color: 'text.secondary',
      display: 'block',
      fontSize: '14px',
      maxWidth: '100%',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      width: '100%',
      whiteSpace: 'nowrap',
    },
    added: {
      color: isDark ? 'rgba(102, 187, 106, 1)' : 'rgba(46, 125, 50, 1)',
      flexShrink: 0,
      fontFamily: 'Roboto, sans-serif',
      fontSize: '14px',
      fontWeight: 500,
    },
    addStudent: {
      color: 'primary.main',
      flexShrink: 0,
      height: '32px',
      width: '32px',
    },
    removeStudent: {
      color: 'text.secondary',
      flexShrink: 0,
      height: '32px',
      width: '32px',
    },
  };
};
